import React from 'react';
import styles from './Layout.module.scss';
import { ArrowLeftIcon, ArrowRightIcon, ChevronRightIcon, Icon, IconButton } from '@eventbrite/marmalade';
import { useScrollableArrows } from '../../hooks/useScrollableArrows';
import { useTranslation } from '../../context/TranslationContext/TranslationContext';

type Props = {
  children: React.ReactNode;
  onViewAllClick?: () => void;
  titleSize?: 'large' | 'small';
  showViewAll?: boolean;
};

const Layout: React.FC<Props> = ({ children, onViewAllClick, showViewAll = true }) => {
  const {
    goodToKnow: title = 'Good to know',
    viewAll: viewAll = 'View all',
    scrollLeft: scrollLeft = 'Scroll left',
    scrollRight: scrollRight = 'Scroll right',
  } = useTranslation();
  const { containerRef, showLeftArrow, showRightArrow, scroll } = useScrollableArrows(244);
  const shouldShowViewAll = React.Children.count(children) > 1 && showViewAll;

  return (
    <div className={styles.wrapper}>
      <div className={styles.headWrapper}>
        <h2 className={styles.title}>{title}</h2>
        {shouldShowViewAll && (
          <button className={styles.viewAll} onClick={onViewAllClick}>
            {viewAll}
            <ChevronRightIcon />
          </button>
        )}
      </div>
      <div className={styles.itemList} ref={containerRef}>
        {showLeftArrow && (
          <div className={styles.leftArrow} onClick={() => scroll('left')}>
            <IconButton aria-label={scrollLeft} outline icon={<ArrowLeftIcon />} />
          </div>
        )}
        {children}
        {showRightArrow && (
          <div className={styles.rightArrow} onClick={() => scroll('right')}>
            <IconButton aria-label={scrollRight} outline icon={<ArrowRightIcon />} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Layout;
